import { useGLTF } from '@react-three/drei';

// freeGltf — release a GLTF's GPU memory (geometries, materials, and their
// textures) AND purge it from the useGLTF cache so the next mount reloads fresh.
//
// Used on mobile to "dump the world map" when entering a splat interior: the
// city GLBs (~24MB decoded to far more in VRAM) are normally kept resident
// (dispose={null}) for an instant return to the street, but that leaves no GPU
// budget for a Gaussian splat on top → iOS OOM. Freeing here lets the splat fit;
// the street reloads (from HTTP cache, so re-decode not re-download) on exit.
// Desktop keeps the model cached and never calls this.
export function freeGltf(root, url) {
  try {
    root?.traverse?.((o) => {
      if (o.geometry) o.geometry.dispose();
      const mats = Array.isArray(o.material) ? o.material : (o.material ? [o.material] : []);
      for (const m of mats) {
        for (const key in m) { const v = m[key]; if (v && v.isTexture) v.dispose(); }
        m.dispose?.();
      }
    });
  } catch { /* best-effort */ }
  try { useGLTF.clear(url); } catch { /* not cached */ }
}
